"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var data_service_1 = require("./data.service");
var CachingDataService = /** @class */ (function (_super) {
    tslib_1.__extends(CachingDataService, _super);
    function CachingDataService(singleLoad, http, urlService, transformator, idFieldName) {
        var _this = _super.call(this, http, urlService, transformator, idFieldName) || this;
        _this.singleLoad = singleLoad;
        _this.objectMaps = new Map();
        _this.objects = [];
        if (singleLoad) {
            _this.loader = _this.list({}, "INIT", true);
        }
        return _this;
    }
    CachingDataService.prototype.save = function (object, exists) {
        if (exists === void 0) { exists = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var storedObject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.save.call(this, object, exists)];
                    case 1:
                        storedObject = _a.sent();
                        this.update(storedObject);
                        this.updateObjects();
                        return [2 /*return*/, storedObject];
                }
            });
        });
    };
    CachingDataService.prototype.list = function (filters, callerId, init) {
        if (init === void 0) { init = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var list, objects;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.singleLoad && !init) {
                            return [2 /*return*/, { page: this.objects }];
                        }
                        return [4 /*yield*/, _super.prototype.list.call(this, filters, callerId)];
                    case 1:
                        list = _a.sent();
                        objects = list instanceof Array ? list : list['page'];
                        this.updateObjects(objects, true);
                        return [2 /*return*/, list];
                }
            });
        });
    };
    CachingDataService.prototype.loadByReference = function (reference) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.load(reference.id)];
            });
        });
    };
    CachingDataService.prototype.load = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var object, rawObject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.singleLoad) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loader];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        object = this.get(id);
                        if (!!object && !object.XO_partially_loaded) {
                            return [2 /*return*/, object];
                        }
                        if (!!this.singleLoad) return [3 /*break*/, 5];
                        return [4 /*yield*/, _super.prototype.loadItem.call(this, id)];
                    case 3:
                        rawObject = _a.sent();
                        return [4 /*yield*/, this.transformator.transformFromServer(rawObject, object)];
                    case 4:
                        object = _a.sent();
                        this.update(object);
                        this.updateObjects();
                        _a.label = 5;
                    case 5: return [2 /*return*/, object];
                }
            });
        });
    };
    CachingDataService.prototype.transformFromServerWrapper = function (rawObject) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var object;
            return tslib_1.__generator(this, function (_a) {
                object = this.get(this.getIdFromObject(rawObject));
                return [2 /*return*/, this.transformator.transformFromServer(rawObject, object)];
            });
        });
    };
    CachingDataService.prototype.delete = function (object) {
        this.removeFromCache(object);
        return _super.prototype.delete.call(this, object);
    };
    CachingDataService.prototype.clearCache = function () {
        this.objectMaps.clear();
        this.objects.splice(0, this.objects.length);
    };
    CachingDataService.prototype.removeFromCache = function (object) {
        this.objectMaps.delete(object[this.idFieldName]);
        this.updateObjects();
    };
    CachingDataService.prototype.get = function (id) {
        return this.objectMaps.get(this.getId(id));
    };
    CachingDataService.prototype.updateObjects = function (objects, partiallyLoaded) {
        var _a;
        var _this = this;
        if (!!objects) {
            objects.forEach(function (object) {
                _this.update(object, partiallyLoaded);
            });
        }
        this.objects.splice(0);
        (_a = this.objects).push.apply(_a, Array.from(this.objectMaps.values()));
    };
    CachingDataService.prototype.update = function (object, partiallyLoaded) {
        if (partiallyLoaded === void 0) { partiallyLoaded = false; }
        var id = this.getIdFromObject(object);
        if (object.XO_DELETED) {
            this.objectMaps.delete(id);
            return;
        }
        if (partiallyLoaded) {
            var loadedObject = this.get(id);
            if (!!loadedObject && !loadedObject.XO_partially_loaded) {
                return;
            }
        }
        object.XO_partially_loaded = partiallyLoaded;
        this.objectMaps.set(id, object);
    };
    CachingDataService.prototype.getChangedObjects = function (timestamp) {
        return this.http.get(this.urlService.getListUrl() + "/since/" + timestamp.getTime(), { withCredentials: true })
            .toPromise()
            .then(this.transformObjectsFromServer.bind(this));
    };
    CachingDataService.prototype.getIdFromObject = function (object) {
        return this.getId(object[this.idFieldName]);
    };
    CachingDataService.prototype.getId = function (id) {
        return "" + id;
    };
    return CachingDataService;
}(data_service_1.DataService));
exports.CachingDataService = CachingDataService;
//# sourceMappingURL=caching.data.service.js.map